import { render, staticRenderFns } from "./CostPlanMaterialItem.vue?vue&type=template&id=542dced4&"
import script from "./CostPlanMaterialItem.vue?vue&type=script&lang=js&"
export * from "./CostPlanMaterialItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports